import { render, staticRenderFns } from "./banner-item.vue?vue&type=template&id=6f9439ed&scoped=true"
import script from "./banner-item.vue?vue&type=script&lang=js"
export * from "./banner-item.vue?vue&type=script&lang=js"
import style0 from "./banner-item.vue?vue&type=style&index=0&id=6f9439ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9439ed",
  null
  
)

export default component.exports